import { AfterViewInit, Component, ElementRef, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { ProjectModel } from 'src/app/models/project.model';
import { MatPaginator } from '@angular/material/paginator';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-projects-promotions-view-sheets',
  templateUrl: './projects-promotions-view-sheets.component.html',
  styleUrls: ['./projects-promotions-view-sheets.component.scss'],
  providers: [DatePipe]
})
export class ProjectsPromotionsViewSheetsComponent implements OnInit, AfterViewInit {

  bodyForm : FormData = new FormData(); 
  sheetSelected: any;
  columnas: string[] = [];
  nameSelected: string = '';
  tabSelected: string = '';
  base64String: string = '';
  workbook: any;
  project: ProjectModel = new ProjectModel();
  flagCodigo: boolean = false;
  flagSinDataCodigo: boolean = false;
  indexCodigo:number = 0;
  dataSource = new MatTableDataSource<any>();
  diagramacionesDataSource = new MatTableDataSource<any>();
  diagramaciones_let : Array<any> = [];
  new_promos : any[] = [];
  filteredPromosMasive: any[] = [];
  searchTermMasive: string = '';

  multipleSheetsSelected: string[] = [];
  validSheets: string[] = [];
  selected_promos_masive : Array<any> = [];
  

  diagramacionesColumns: string[] = ['select','nombre_proyecto', 'alias', 'medio', 'promociones_faltantes',  'promociones', ];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChildren('searchInputMasive') searchInputMasive!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChildren('searchInputRow') searchInputsRow!: QueryList<ElementRef<HTMLInputElement>>;
  allUsers: any;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private projectService : ProjectsService,
    private main : MainService,
    private dialogRef: MatDialogRef<ProjectsPromotionsViewSheetsComponent>,
    private datePipe: DatePipe,
    private userService: UsersService,
  ) { 
      this.project = this.data.project;
  }

  ngOnInit(): void {
    this.userService.getUserList().subscribe((res: any) => {
        this.allUsers = res;
        this.nameSelected = this.data.sheets[0];
        this.tabSelected = this.data.sheets[0];
        this.base64String = this.data.base64String
        this.previewSheet(this.nameSelected);
        this.findValidSheets();
        this.preloadFormData();
        this.filteredPromosMasive = [...this.new_promos];
    });

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  toStringArr(arra : Array<any>){
    return arra.toString();
  }

  changeSheet(event: MatSelectChange) {
    this.main.ShowLoading();
    this.flagSinDataCodigo = false;
    this.previewSheet(event.value);
    this.main.HideLoading(); 
  }

  changeTab(sheetName: string) {
    this.main.ShowLoading();
    this.tabSelected = sheetName;
    this.flagSinDataCodigo = false;
    this.previewSheet(sheetName);
    this.main.HideLoading();
  }

  findValidSheets() {
    const binary = atob(this.base64String);
    const len = binary.length;
    const buffer = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      buffer[i] = binary.charCodeAt(i);
    }
    const workbook = XLSX.read(buffer, { type: 'array', cellDates: true, cellNF: true });

    this.validSheets = workbook.SheetNames.filter((nameSheet: string) => {
      const worksheet = workbook.Sheets[nameSheet];
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const headers = data[0] as string[];
      return headers && headers.includes("CODIGO PRINCIPAL");
    });
  }



  previewSheet(nameSheet: string){

    const binary = atob(this.base64String);
    const len = binary.length;
    const buffer = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      buffer[i] = binary.charCodeAt(i);
    }

 
    this.workbook = XLSX.read(buffer, { type: 'array', cellDates: true, cellNF: true });


    if (this.workbook.SheetNames.includes(nameSheet)) {
      const worksheet = this.workbook.Sheets[nameSheet];
 
      const data: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      const sheetWithFormats = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: true });
      const headers = sheetWithFormats[0] as string[];

      if (!headers.includes('RESPONSABLE_PROMOCION')) {
        data.forEach(row => {
          row['RESPONSABLE_PROMOCION'] = null;
        });
      }
      
      data.forEach((row, rowIndex) => {
        headers.forEach((header, colIndex) => {
          const cell = worksheet[XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex })];
          if (cell && cell.t === 'd') {
            row[header] = this.datePipe.transform(row[header], 'dd/MM/yyyy');
          }
        });
      });
      if (data.length > 0) {
        const columnSet = new Set<string>();
        data.forEach(row => {
          Object.keys(row).forEach(key => {
            columnSet.add(key);
          });
        });
        this.columnas = Array.from(columnSet);
        this.sheetSelected = data;
        this.dataSource.data = data; 
        console.log("ENTRA A DATA")
        console.log(data)
      } else {
        this.columnas = [];
        this.sheetSelected = [];
        this.dataSource.data = [];
      }
      if(this.columnas == undefined){
        this.columnas = [];
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Esta hoja no contiene datos, por favor intenta con otra.'
        });
      }

      if (this.columnas.includes("CODIGO PRINCIPAL")) {
          this.flagCodigo = true;
      
      } else {
          this.flagCodigo = false;
      }


      const indexCodigoKey = "CODIGO PRINCIPAL";

      this.sheetSelected.map( (item:any) => {
        if(item[indexCodigoKey] == undefined){
          this.flagSinDataCodigo = true;
        }
      })

      if(this.flagSinDataCodigo == true && this.flagCodigo){
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Se detectaron valores vacíos en la columna CODIGO PRINCIPAL, por favor revise que todos los renglones tengan valor en esta columna para poder continuar.'
        });
      }

    } else {
      console.error('No se encontró la hoja:', nameSheet);
    }
  }

  mergedSheetsExcel : any;

  validateResponsables(data: any[]): string[] {
    const invalidEmails: string[] = [];
    if (!this.allUsers || this.allUsers.length === 0) {
      console.error("Lista de usuarios no cargada.");
      return []; 
    }

    const existingEmails = new Set(this.allUsers.map((u: any) => u.email.toLowerCase()));

    data.forEach(row => {
      if (row.hasOwnProperty('RESPONSABLE_PROMOCION')) {
        const responsableEmail = row['RESPONSABLE_PROMOCION'];
        if (responsableEmail && responsableEmail.trim() !== '' && responsableEmail.trim() !== '-' && responsableEmail.trim() !== 'ABIERTA') {
          const emails = String(responsableEmail).split(',').map(email => email.trim().toLowerCase());
          emails.forEach(email => {
            if (email && !existingEmails.has(email)) {
              if (!invalidEmails.includes(responsableEmail)) { // Evita duplicados en el mensaje de error
                invalidEmails.push(responsableEmail);
              }
            }
          });
        }
      }
    });
    return invalidEmails;
  }

  uploadSheet(){

    const sheetsToProcess = this.multipleSheetsSelected;
    
    let allData: any[] = [];
    const allColumns = new Set<string>();
    
    sheetsToProcess.forEach(sheetName => {
      const worksheet = this.workbook.Sheets[sheetName];
      if (worksheet) {
        const sheetData: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        
        // Verifica si la columna 'responsable_promocion' existe en alguna de las filas.
        const hasResponsableColumn = sheetData.some(row => row.hasOwnProperty('RESPONSABLE_PROMOCION'));
        if (sheetData.length > 0 && !hasResponsableColumn) {
          sheetData.forEach(row => {
            row['RESPONSABLE_PROMOCION'] = null;
          });
        }
        
        sheetData.forEach(row => {
          for (const key in row) {
            if (row.hasOwnProperty(key) && row[key] instanceof Date) {
              row[key] = this.datePipe.transform(row[key], 'dd/MM/yyyy');
            }
          }
        });
        if (sheetData.length > 0) {
          Object.keys(sheetData[0] as any).forEach(col => allColumns.add(col));
          allData = allData.concat(sheetData);
        }
      }
    });

    // Validar responsables antes de continuar
    if (allColumns.has('RESPONSABLE_PROMOCION')) {
      const invalidEmails = this.validateResponsables(allData);
      if (invalidEmails.length > 0) {
        Swal.fire({
          icon: 'error',
          title: 'Usuarios no válidos',
          html: `Se encontraron correos de responsables no registrados en el sistema: <br><b>${invalidEmails.join('<br>')}</b>. <br>Por favor, corrija el archivo e intente de nuevo.`
        });
        this.bodyForm.delete('blob');
        return;
      }
    }

    const finalColumns = Array.from(allColumns);
    const mergedWorksheet = XLSX.utils.json_to_sheet(allData, { header: finalColumns });

    const newWorkbook = XLSX.utils.book_new(); 
    XLSX.utils.book_append_sheet(newWorkbook, mergedWorksheet, 'hoja1');

    this.mergedSheetsExcel = newWorkbook;

    const newWorkbookBuffer = XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([newWorkbookBuffer], { type: 'application/octet-stream' });

    this.bodyForm.append('blob', blob, this.data.fileName);

    Swal.fire({
      icon: 'info',
      title: 'Validando archivo...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    //  this.projectService.saveSheetPromociones(this.bodyForm).subscribe((x:any)=>{

    this.projectService.validateSheetPromociones(this.bodyForm).subscribe((x:any)=>{
      if(x.message = "Success"){
        if(x.data.diagramas_new.length != 0){
          this.diagramaciones_let = x.data.diagramas_new;
          this.diagramacionesDataSource.data = this.diagramaciones_let; 
          this.diagramaciones_let.forEach(d => {
            d.searchTerm = '';
            d.filteredPromos = [...x.data.promo_lista];
          });
          this.new_promos = x.data.promo_lista;
          this.filteredPromosMasive = [...this.new_promos];

            const firstSheetName = newWorkbook.SheetNames[0];
            const worksheet = newWorkbook.Sheets[firstSheetName];
            const data = XLSX.utils.sheet_to_json(worksheet);
            
            const columnSet = new Set<string>();
            data.forEach((row: any) => {
              Object.keys(row).forEach(key => columnSet.add(key));
            });
            this.columnas = Array.from(columnSet);

            this.sheetSelected = data;
            this.dataSource.data = data;


        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Se detectaron promociones en diagramaciones que ya no existen en este nuevo archivo, por favor, seleccione nuevas promociones para poder continuar.'
        });

        }else{
            this.confirmUploadSheet();
        }

     // Swal.fire({
     //   icon: 'success',
     //   title: 'Archivo subido',
     //   text: 'Archivo subido exitosamente'          
     // }).then(() => {            
     //   this.dialogRef.close({ reload: true });
     // });
      }
      else{
         Swal.fire({
           icon: 'error',
           title: 'Error al guardar',
           text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
         });
      }
    });

  }

  validate_promos() {
    const allPromosSelected = this.diagramaciones_let.every(
      (diagramacion) => diagramacion.promociones && diagramacion.promociones.length > 0
    );

    if (allPromosSelected) {
      this.confirmUploadSheet(true);
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Promociones faltantes',
        text: 'Por favor, asegúrese de seleccionar al menos una promoción para cada diagramación afectada antes de continuar.',
      });
    }
  }

  selectedDiagrams : Array<any> = []

 selectAllValue : boolean = false; 
  selectAll(event: any): void {
    if (event.target.checked) {
      this.selectedDiagrams = this.diagramacionesDataSource.data.map(d => d.id);
    } else {
      this.selectedDiagrams = [];
    }
    console.log(this.selectedDiagrams);
  }

  onSelectOpened(isMasive: boolean, index?: number) {
    setTimeout(() => {
      let input;
      if (isMasive) {
        input = this.searchInputMasive.first;
      } else if (index !== undefined) {
        input = this.searchInputsRow.toArray()[index];
      }
      input?.nativeElement?.focus();
    }, 100);
  }

  clearSearch(isMasive: boolean, element?: any) {
    if (isMasive) {
      this.searchTermMasive = '';
      this.filterPromosMasive();
    } else if (element) {
      element.searchTerm = '';
      this.filterPromosRow(element);
    }
  }

  filterPromosMasive() {
    const term = (this.searchTermMasive || '').toLowerCase();
    const selected = new Set(this.selected_promos_masive || []);
    
    const selectedPromos = this.new_promos.filter(p => selected.has(p));
    const filtered = this.new_promos.filter(p => !selected.has(p) && p.toLowerCase().includes(term));
    
    this.filteredPromosMasive = [...selectedPromos, ...filtered].sort((a, b) => {
        const aIsSelected = selected.has(a);
        const bIsSelected = selected.has(b);
        return (bIsSelected ? 1 : 0) - (aIsSelected ? 1 : 0);
    });
  }

  filterPromosRow(element: any) {
    const term = (element.searchTerm || '').toLowerCase();
    const selected = new Set(element.promociones || []);
    
    const selectedPromos = this.new_promos.filter(p => selected.has(p));
    const filtered = this.new_promos.filter(p => !selected.has(p) && p.toLowerCase().includes(term));
    
    element.filteredPromos = [...selectedPromos, ...filtered].sort((a, b) => {
        const aIsSelected = selected.has(a);
        const bIsSelected = selected.has(b);
        return (bIsSelected ? 1 : 0) - (aIsSelected ? 1 : 0);
    });
  }

  clearAllPromosMasive() {
    this.selected_promos_masive = [];
    this.filterPromosMasive();
  }

  clearAllPromosRow(element: any) {
    // Solo modificar si realmente hay algo que limpiar
    if (element.promociones && element.promociones.length > 0) {
      element.promociones = [];
      element.modificado = true;
      this.filterPromosRow(element);
    }
  }

  toggleSelection(id: string): void {
    const index = this.selectedDiagrams.indexOf(id);
    if (index > -1) {
      this.selectedDiagrams.splice(index, 1);  
    } else {
      this.selectedDiagrams.push(id); 
    }

    console.log(this.selectedDiagrams);
    //this.promotionsChange = true;
  }


  countModificadas(){
    return this.diagramaciones_let.filter(d => d.modificado && d.promociones.length > 0).length;
  }

  confirmUploadSheet(savePromotions : boolean = false){

   // const hojasAEliminar = this.workbook.SheetNames.filter((name:string) => name != this.nameSelected);
   // this.workbook.SheetNames = this.workbook.SheetNames.filter((name:string) => !hojasAEliminar.includes(name));
   //
   // hojasAEliminar.forEach( (name:string) => {
   //     delete this.workbook.Sheets[name];
   // });


    const newWorkbookBuffer = XLSX.write(this.mergedSheetsExcel, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([newWorkbookBuffer], { type: 'application/octet-stream' });

   // const newWorkbookBuffer = XLSX.write(this.workbook, { bookType: 'xlsx', type: 'array' });
   // const blob = new Blob([newWorkbookBuffer], { type: 'application/octet-stream' });

    this.bodyForm.append('blob', blob, this.data.fileName);

    Swal.fire({
      icon: 'info',
      title: 'Subiendo archivo...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.projectService.saveSheetPromociones(this.bodyForm).subscribe((x:any)=>{
      if(x.message = "Success"){

          if(savePromotions){
            this.projectService.updateDiagramPromosMasive(this.diagramaciones_let).subscribe((x:any)=>{
                if(x.message = "Success"){
                   Swal.fire({
                     icon: 'success',
                     title: 'Archivo subido',
                     text: 'Archivo subido exitosamente'          
                   }).then(() => {            
                     this.dialogRef.close({ reload: true });
                   });     
                }else{
                    Swal.fire({
                      icon: 'error',
                      title: 'Error al guardar',
                      text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
                    });
                }
            });

          }else{
             Swal.fire({
               icon: 'success',
               title: 'Archivo subido',
               text: 'Archivo subido exitosamente'          
             }).then(() => {            
               this.dialogRef.close({ reload: true });
             });
          }
      }
      else{
         Swal.fire({
           icon: 'error',
           title: 'Error al guardar',
           text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
         });
      }
    });

  }

  applyPromosToAll() {
    if (!this.selected_promos_masive || this.selected_promos_masive.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'Sin selección',
        text: 'Por favor, seleccione al menos una promoción de la lista para aplicar.',
      });
      return;
    }

    if (this.selectedDiagrams.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'Sin selección',
        text: 'Por favor, seleccione al menos una diagramación de la tabla.',
      });
      return;
    }

    this.diagramaciones_let.filter(d => this.selectedDiagrams.includes(d.id)).forEach(diagramacion => {
      if (!diagramacion.promociones) {
        diagramacion.promociones = [];
      }
      const originalPromosCount = diagramacion.promociones.length;

      const combinedPromos = [...diagramacion.promociones, ...this.selected_promos_masive];
      diagramacion.promociones = [...new Set(combinedPromos)];

      if (diagramacion.promociones.length !== originalPromosCount) {
        diagramacion.modificado = true;
      }
    });

    this.clearAllPromosMasive();
    this.selectedDiagrams = [];

  }


  preloadFormData(){
    this.bodyForm.append('id_proj', this.project.id.toString() as string); 
    this.bodyForm.append('folder', this.project.folder as string);      
  }

}
